import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import AxiosInstance from "../../components/Axios";
import {MRT_ColumnFiltersState, MRT_PaginationState, MRT_SortingState} from "material-react-table";
import {
    VersOreApiResponse,
    mapJsonToVersOreApiResponse,
    mapJsonToProgettiDTOApiResponse,
    mapJsonToNodiDTOApiResponse,
    mapJsonToAttivitaDTOApiResponse,
    VersOre,
    mapVersOreToJson,
    ProgettiDTOApiResponse,
    NodiDTOApiResponse,
    AttivitaDTOApiResponse,
    ProgettiApiResponse,
    NodiApiResponse,
    mapJsonToNodiApiResponse,
    mapJsonToProgettiApiResponse,
    mapJsonToAttivitaApiResponse,
    AttivitaApiResponse,
    mapJsonToVersOre,
    VersOreDTOApiResponse,
    mapJsonToVersOreDTOApiResponse, DipendentiApiResponse, mapJsonToDipendentiApiResponse
} from "./types";
import {sortingParam, columnFiltersParamWithDateRange} from "../../common/Services";
import {Buffer} from "buffer";
import {format} from "date-fns";
import * as Yup from "yup";


const moment = require('moment')

export function useGetVersOreDTO(
    pagination: MRT_PaginationState,
    columnFilters: MRT_ColumnFiltersState,
    globalFilter: string,
    sorting: MRT_SortingState,
 ) {
    return useQuery<VersOreDTOApiResponse>({
        queryKey: [
            'fetchVersOreDTO',
            columnFilters, // refetch when columnFilters changes
            globalFilter,  // refetch when globalFilter changes
            pagination.pageIndex, // refetch when pagination.pageIndex changes
            pagination.pageSize, // refetch when pagination.pageSize changes
            sorting, // refetch when sorting changes
        ],
        queryFn: async () => {
            // Get isAdmin and coddip from localStorage at the start

           // console.log(localStorage.getItem('keyrole'));
           // console.log(localStorage.getItem('coddip'));


            let coddip = localStorage.getItem('coddip') || 'NN';
            let impcoddip = localStorage.getItem('impcoddip') || 'NN';

            const role = localStorage.getItem('keyrole') || '';
            // let coddip = localStorage.getItem('coddip') || 'NN';


                    if (role.includes('TimeReportAdmin')) {
                                coddip = (impcoddip === 'NN' || impcoddip === '') ? '' : impcoddip;
                            } else if (role.includes('TimeReportUser')) {
                                coddip = localStorage.getItem('coddip') || 'NN';
                            } else if (role.includes('TimeReportCust')) {
                                coddip = 'NN';
                            } else if (role.includes('TimeReportAgent')) {
                                coddip = '';
                            }




            const myLimit=pagination.pageSize
            const myOffset =
                pagination.pageIndex === 0
                    ? '0'
                    : `${pagination.pageSize * pagination.pageIndex}`;

            let myURL = `?limit=${myLimit}&offset=${myOffset}&search=${globalFilter ?? ''}${columnFiltersParamWithDateRange(
                columnFilters,
                'VBT00'
            )}&ordering=${sortingParam(sorting, 'VBT00')}`;

            if (coddip !== '') {
                        myURL += `&VBT00_CODDIP=${coddip}`;
                }

            const response = await AxiosInstance.get(`versoredto/${myURL}`);

            return mapJsonToVersOreDTOApiResponse(response.data);
        },
        refetchOnWindowFocus: false,
    });
}




// export function useGetVersOre(id: number) {
//   return useQuery<VersOre>({
//     queryKey: ['fetchVersOre',id],
//     queryFn: async () => {
//       const response = await AxiosInstance.get('versore/'+id+'/');
//
//       // console.log("VERSORE: ",response);
//       return mapJsonToVersOre(response.data.data.versore);
//     },
//     refetchOnWindowFocus: false,
//   });
// }

export function useGetVersOre(id: number) {
  return useQuery<VersOre>({
    queryKey: ['fetchVersOre', id],
    queryFn: async () => {
      const response = await AxiosInstance.get('versore/' + id + '/');


      const transformedData = mapJsonToVersOre(
        response.data?.data?.VersOre
      );


      return transformedData;
    },
    refetchOnWindowFocus: false,
  });
}




export function useCreateVersOre() {
  const queryClient = useQueryClient();
  return useMutation({

    mutationFn: async (versore: VersOre) => {
      if (versore.datareg) {
        versore.datareg = moment(versore.datareg).format('YYYY-MM-DD');
      }

      if (versore.datains) {
        versore.datains = moment(versore.datains).format('YYYY-MM-DD');
      }

      if (versore.inizlav) {
        console.log('prima:',versore.inizlav);
        versore.inizlav = moment(versore.inizlav).format('YYYY-MM-DDTHH:mm');
        console.log('dopo:',versore.inizlav);
      }

      if (versore.finelav) {
        versore.finelav = moment(versore.finelav).format('YYYY-MM-DDTHH:mm');
      }


       const response = await AxiosInstance.post('versore/0/', mapVersOreToJson(versore));
       return response.data;

      // return AxiosInstance.post('versore/0/',mapVersOreToJson(versore));
    },

     onSuccess: async (data, variables) => {

        const op = 'INS';
        const dittaorig = data?.data?.versore?.PD44_DITTA_CG18;
        const progorig = data?.data?.versore?.PD44_CODPROG_PD14;
        const nrrelorig = data?.data?.versore?.PD44_PRGMVORE_PD31;

        if (op && dittaorig && progorig && nrrelorig) {
            // console.log(op,dittaorig,nrrelorig)
            await versOreDup({ op, dittaorig, progorig, nrrelorig });
       }

       queryClient.invalidateQueries({ queryKey: ['fetchVersOreDTO'] });

   }, //refetch VersoOre after mutation, disabled for demo
     });
}

 export function useUpdateVersOre() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (versore: VersOre) => {
      if (versore.datareg) {
        versore.datareg = moment(versore.datareg).format('YYYY-MM-DD');
      }
      if (versore.datains) {
        versore.datains = moment(versore.datains).format('YYYY-MM-DD');
      }
      if (versore.inizlav) {
        versore.inizlav = moment(versore.inizlav).format('YYYY-MM-DDTHH:mm');
      }

      if (versore.finelav) {
        versore.finelav = moment(versore.finelav).format('YYYY-MM-DDTHH:mm');
      }



        const response = await AxiosInstance.patch('versore/'+versore.id+'/',mapVersOreToJson(versore));
        return response.data;
    },
    onSuccess: async (data, variables) => {
      const op = 'UPD';
      const dittaorig = data?.data?.versore?.PD44_DITTA_CG18;
      const progorig = data?.data?.versore?.PD44_CODPROG_PD14;
      const nrrelorig = data?.data?.versore?.PD44_PRGMVORE_PD31;

      if (op && dittaorig && progorig && nrrelorig) {
        await versOreDup({ op, dittaorig, progorig, nrrelorig });
      }

      queryClient.invalidateQueries({ queryKey: ['fetchVersOreDTO'] });
      queryClient.invalidateQueries({ queryKey: ['fetchReportAgentiVersore'] });
    },
  });
}



export function useDeleteVersOre() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: number) => {
    const response = await AxiosInstance.delete('versore/'+id+'/');
     return  response.data
    },
     onSuccess: async (data, variables) => {
      const op = 'DEL';
      const dittaorig = data?.data?.versore?.PD44_DITTA_CG18;
      const progorig = data?.data?.versore?.PD44_CODPROG_PD14;
      const nrrelorig = variables.toString();

      if (op && dittaorig && progorig && nrrelorig) {


        await versOreDup({ op, dittaorig, progorig, nrrelorig });
      }

      queryClient.invalidateQueries({ queryKey: ['fetchVersOreDTO'] });
    },
  });
}


export function useGetProgettiByDip() {
  return useQuery<ProgettiApiResponse>({
    queryKey: ['fetchProgettiByDip'],
    queryFn: async () => {

            let coddip = localStorage.getItem('coddip') || 'NN';
            let ditta = localStorage.getItem('keyidazienda') || 0;

            const keyrole = localStorage.getItem("keyrole") || "";

            // console.log(keyrole);

            const isAdmin =  keyrole.includes('TimeReportAdmin')

            let myURL = 'progettibydip/?limit=10000&offset=0'+'&CODDIP='+coddip+'&DITTA='+ditta;

            // console.log('isAdmin',isAdmin)
            if (ditta==12) {

                        myURL = 'progettibydip/?limit=10000&offset=0'+'&CODDIP='+coddip;
                }


            if (isAdmin) {

                        myURL = 'progetti/?limit=10000&offset=0';
                }


    // if (coddip && ditta) {
    //     const response = await AxiosInstance.get('progettibydip/?limit=10000&offset=0'+'&CODDIP='+coddip+'&DITTA='+ditta);
        const response = await AxiosInstance.get(myURL);

            return mapJsonToProgettiApiResponse(response.data)

    },
    refetchOnWindowFocus: false,
  });
}


export function useGetProgetti(ditta: number) {
  return useQuery<ProgettiApiResponse>({
    queryKey: ['fetchProgetti',ditta],
    queryFn: async () => {

    if (ditta==0) {
        const response = await AxiosInstance.get('progetti/?limit=10000&offset=0');
        return mapJsonToProgettiApiResponse(response.data)
    } else{
        const response = await AxiosInstance.get('progetti/?limit=10000&offset=0&VBT01_DITTA='+ditta);
        return mapJsonToProgettiApiResponse(response.data)
    }

    },
    refetchOnWindowFocus: false,
  });
}

export function useGetProgettiNotDatiProg(ditta: number) {
  return useQuery<ProgettiApiResponse>({
    queryKey: ['fetchProgettiNotDatiProg',ditta],
    queryFn: async () => {

    if (ditta==0) {
        const response = await AxiosInstance.get('progettinotdatiprog/?limit=10000&offset=0');
        return mapJsonToProgettiApiResponse(response.data)
    } else{
        const response = await AxiosInstance.get('progettinotdatiprog/?limit=10000&offset=0&VBT01_DITTA='+ditta);
        return mapJsonToProgettiApiResponse(response.data)
    }

    },
    refetchOnWindowFocus: false,
  });
}








export function useGetDipendenti(ditta: number, coddip: string) {
  return useQuery<DipendentiApiResponse>({
    queryKey: ['fetchDipendenti', ditta, coddip],
    queryFn: async () => {
      let url = 'dipendenti/?limit=10000&offset=0&VBT03_FLGDEL=N';

      if (ditta !== 0) {
        url += `&VBT03_DITTA=${ditta}`;
        if (coddip) {
          url += `&VBT03_CODDIP=${coddip}`;
        }
      }

      const response = await AxiosInstance.get(url);
      return mapJsonToDipendentiApiResponse(response.data);
    },
    refetchOnWindowFocus: false,
  });
}



export function useGetDipendentiByUsername(ditta: number, username: string) {
  return useQuery<DipendentiApiResponse>({
    queryKey: ['fetchDipendentiByUsername', ditta, username],
    queryFn: async () => {
      let url = 'dipendenti/?limit=10000&offset=0';

      if (ditta !== 0) {
        url += `&VBT03_DITTA=${ditta}`;
        if (username) {
          url += `&VBT03_USERNAME=${username}`;
        }
      }

      const response = await AxiosInstance.get(url);
      return mapJsonToDipendentiApiResponse(response.data);
    },
    refetchOnWindowFocus: false,
  });
}









export function useGetNodi(idprog: string) {
  return useQuery<NodiApiResponse>({
    queryKey: ['fetchNodi',idprog ?? ''],
    queryFn: async () => {
      // console.log("Call api with:",idprog)
      let ditta = '0'; // Initialize with default value
      let codprog = 'NN'; // Initialize with default value

      if (idprog && idprog.includes('-')) {
         [ditta, codprog] = idprog.split('-');
      }

      const response = await AxiosInstance.get('nodi/?limit=10000&offset=0&VBT04_CODPROG_VBT01='+codprog+'&VBT04_DITTA='+ditta);

      return mapJsonToNodiApiResponse(response.data)

      // const json = (response.data) as ClientiApiResponse;
      //console.log(response.data)
      // return json;
    },
    refetchOnWindowFocus: false,
  });
}

export function useGetNodiByCodProg(codprog: string) {
  return useQuery<NodiApiResponse>({
    queryKey: ['fetchNodiByCodProg',codprog ?? ''],
    queryFn: async () => {
      // console.log("Call api with:",idprog)

      const response = await AxiosInstance.get('nodi/?limit=10000&offset=0&VBT04_CODPROG_VBT01='+codprog);

      return mapJsonToNodiApiResponse(response.data)

      // const json = (response.data) as ClientiApiResponse;
      //console.log(response.data)
      // return json;
    },
    refetchOnWindowFocus: false,
  });
}




export function useGetAttivita(idprog: string) {
  return useQuery<AttivitaApiResponse>({
    queryKey: ['fetchAttivita',idprog ?? ''],
    queryFn: async () => {

      let ditta = '0'; // Initialize with default value
      let codprog = 'NN'; // Initialize with default value

      if (idprog && idprog.includes('-')) {
        [ditta, codprog] = idprog.split('-');
      }
      const response = await AxiosInstance.get('attivita/?limit=10000&offset=0&VBT05_CODPROG_VBT01='+codprog+'&VBT04_DITTA='+ditta);

      return mapJsonToAttivitaApiResponse(response.data)

      // const json = (response.data) as ClientiApiResponse;
      //console.log(response.data)
      // return json;
    },
    refetchOnWindowFocus: false,
  });
}

export async function versOreDup({ op, dittaorig, progorig, nrrelorig }: { op: string; dittaorig: string; progorig: string; nrrelorig: string }) {
  try {

    const response = await AxiosInstance.get('versoredup', {
      params: { op, dittaorig,progorig, nrrelorig }
    });
    // console.log('Duplication response:', response.data);
    // Return the response data
    return response.data;
  } catch (error) {
    // Handle errors, log them, or rethrow if necessary
    console.error('Error during duplication:', error);
    throw new Error('Duplication failed');
  }
}

export type VersOreCopilotRewriteRequest = {
  rewriteType: string;
  maxChars: number;
  inputText: string;
  rewritePrompt: string;
};

export type VersOreCopilotRewriteResponse = {
  text: string;
  clipped: boolean;
  maxChars: number;
  rewriteType: string;
};

export async function rewriteVersOreNoteWithCopilotApi(
  payload: VersOreCopilotRewriteRequest
): Promise<VersOreCopilotRewriteResponse> {
  const response = await AxiosInstance.post('versore/copilot-rewrite/', {
    rewrite_type: payload.rewriteType,
    max_chars: payload.maxChars,
    input_text: payload.inputText,
    rewrite_prompt: payload.rewritePrompt,
  });

  const data = response?.data?.data || {};

  return {
    text: String(data.text || ''),
    clipped: Boolean(data.clipped),
    maxChars: Number(data.max_chars || payload.maxChars),
    rewriteType: String(data.rewrite_type || payload.rewriteType),
  };
}

export async function jasperVersoreBlob( fromDate: Date, toDate: Date, formato: String) {
  try {
    const username = 'jasperadmin';
    const password = 'Tibco2024@';
    const base64encodedData = Buffer.from(`${username}:${password}`).toString('base64');

    const fromDateString = fromDate ? format(fromDate, 'yyyy-MM-dd') : '';
    const toDateString = toDate ? format(toDate, 'yyyy-MM-dd') : '';

         let pag = '';
             if (formato === 'xlsx') {
                pag = 'ignorePagination=true&'
            }


    const response = await fetch(`${BASE_URL_JASPERSERVER}/rest_v2/reports/reports/repversore${formato}.${formato}?${pag}datainizio=${fromDateString}&datafine=${toDateString}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/'+formato,
        'Authorization': `Basic ${base64encodedData}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch the report');
    }

    const blob = await response.blob();
    return blob;
  } catch (error) {
    console.error('Error generating report:', error);
    throw error; // Rethrow the error to handle it in the calling code if needed
  }
};

const dateOrEmpty = () =>
  Yup.date()
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? undefined : value))
    .typeError("Data deve essere una data valida");


export const validationSchema = Yup.object().shape({
  datareg: dateOrEmpty(),
  datains: dateOrEmpty(),
  inizlav: dateOrEmpty(),
  finelav: dateOrEmpty(),
  id: Yup.number(),
  qtalav: Yup.number(),
  variante: Yup.string(),
  idprog: Yup.string().required("Il Progetto è obbligatorio"),
  idnodo: Yup.string().required("Il Nodo è obbligatorio"),
  idatt: Yup.string().required("L'attività è obbligatoria"),
  oreord: Yup.number().typeError("Ore deve essere un numero"),
  minord: Yup.number(),
  opzione: Yup.string(),
  note: Yup.string().required("Le note sono obbligatorie"),
  km: Yup.number().typeError("Km deve essere un numero"),
  trasf: Yup.number().typeError("Trasf deve essere un numero"),
  luogo: Yup.string().required("Il luogo è obbligatorio"),
});


export const validationSchemaVersOre = Yup.object().shape({
    datareg: Yup.date()
        .nullable()
        .transform((value, originalValue) => {
            if (originalValue === "") {
                return undefined;
            }
            return value;
        })
        .typeError("Data deve essere una data valida"),
    datains: Yup.date()
        .nullable()
        .transform((value, originalValue) => {
            if (originalValue === "") {
                return undefined;
            }
            return value;
        })
        .typeError("Data deve essere una data valida"),
        id: Yup.number(),
        variante: Yup.string(),
        idprog: Yup.string().required("Il Progetto è obbligatorio"),
        idnodo: Yup.string().required("Il Nodo è obbligatorio"),
        idatt: Yup.string().required("L'attività è obbligatoria"),
        oreord: Yup.number().required("Le ore sono obbligatorie").typeError("Ore deve essere un numero").moreThan(0, "Ore/Min devono essere maggiori di 0"),
        // minord: Yup.number().required("I minuti sono obbligatori"),
        opzione: Yup.string(),
        note: Yup.string().required("Le note sono obbligatorie"),
        km: Yup.number().typeError("Km deve essere un numero"),
        trasf: Yup.number().typeError("Trasf deve essere un numero"),
        luogo: Yup.string().required("Il luogo è obbligatorio"),
        orestraord: Yup.number().typeError("Ore deve essere un numero"),
        minstraord: Yup.number().required("I minuti sono obbligatori"),

    });
